import type { RootState } from "../store"

export const authSelector = (state: RootState) => state.auth
